/* eslint-disable import/no-cycle */

import { AppointmentNotaryType, IAppointment } from './appointments';
import { IDocument } from './file';
import { ILocation } from './location';
import { IPayment } from './payment';
import { ITransactionType } from './services';
import { IUser } from './user';

export enum TransactionStatusEnum {
  ACTIVE = 'ACTIVE',
  MATCHED = 'MATCHED',
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
}

export enum SignatoryType {
  BUYER = 'BUYER',
  SELLER = 'SELLER',
}

export const appointmentTypeOptionsArray = [
  {
    label: 'In Person',
    value: AppointmentNotaryType.IN_PERSON,
  },
  {
    label: 'RON',
    value: AppointmentNotaryType.RON,
  },
];

export interface IAddress {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  coordinate?: any[];
}

export interface ISignatory {
  type: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  id: string;
}

export interface ITransaction {
  id: string;
  status: TransactionStatusEnum;
  reference: string;
  description: string;
  createdAt: string;
  appointment?: IAppointment[];
  signatories: ISignatory[];
  createdBy: IUser;
  isPaid: boolean;
  notary?: IUser;
  requestedNotary?: IUser[];
  fee: number | string;
  transactionType: ITransactionType;
  clientFee: number;
  payment?: IPayment[];
  documents?: IDocument[];
  assigners: IUser[];
  location?: ILocation;
  requiredScanDoc?: boolean;
  returnShippingAddress?: IAddress;
}
